import type { Currency } from '@ps/web-core-enums';

export interface TimeLimit {
  limit: number;
  limitMin: number;
  limitMax: number;
}

export interface Limits {
  daily: TimeLimit;
  weekly: TimeLimit;
  monthly: TimeLimit;
}

export interface WeeklyLimits {
  pokerLimit: number;
  sportLimit: number;
}

export interface LossLimitType {
  type: LossLimitValue;
  amount: number;
  currency: Currency;
}

export interface ResponsibleGamingLimitsPayload {
  currency: Currency;
  rate: number;
  daily: { limit: number; previousLimit: number };
  weekly: { limit: number; previousLimit: number };
  monthly: { limit: number; previousLimit: number };
}

export enum LossLimitValue {
  Daily = 17,
  Weekly = 30,
  Monthly = 18
}
